import { FC, PropsWithChildren } from 'react';

import { useApplication } from '../hooks/use-application';
import { ApplicationConfig, ApplicationEnv } from '../lib/application';

interface ApplicationProviderProps extends ApplicationConfig, PropsWithChildren {
	env: ApplicationEnv;
}

export const ApplicationProvider: FC<ApplicationProviderProps> = ({ children, env, ...config }) => {
	const { initialize, isInitialized } = useApplication();

	if (!isInitialized) {
		initialize(env, config);
		return null;
	}

	return <>{children}</>;
};
